import("./bootstrap.js");
import("./filemanager.js")
import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { InertiaProgress } from "@inertiajs/progress";
import ImageHelper from "./Helpers/image_helper";
import DateHelper from "./Helpers/date_helper";
import TitleHelper from "./Helpers/title_limit_helper";
import {VueMasonryPlugin} from "vue-masonry";
import inertiaTitle from 'inertia-title/vue3';
import VueSocialSharing from 'vue-social-sharing'
import { createI18n } from 'vue-i18n';
import messages from './locales';
import { createVuetify } from 'vuetify';
import 'vuetify/styles'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import bootbox from "bootbox";
window.bootbox = bootbox;


const vuetify = createVuetify({ components, directives });
const savedLocale = localStorage.getItem('locale') || 'km';
const i18n = createI18n({
    legacy: false,
    locale: savedLocale,
    messages,
    missingWarn: false,
    fallbackWarn: false,
});

createInertiaApp({
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({ el, App, props, plugin }) {
        createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(i18n)
            .use(vuetify)
            .use(VueMasonryPlugin)
            .use(inertiaTitle)
            .use(VueSocialSharing)
            .mixin(ImageHelper)
            .mixin(DateHelper)
            .mixin(TitleHelper)
            .mixin({ methods: { route } })
            .mount(el)
    },
});

InertiaProgress.init({
    delay: 0,
    color: '#4c9ac7',
    includeCSS: true,
    showSpinner: false,
});
